<template>
  <div style="padding: 0 16px 12px;">
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="time" label="洗护时间">
        <template #default="scope">
          {{serviceType == -2?scope.row.showTime:scope.row.time}}
        </template>
      </el-table-column>
      <el-table-column property="" label="客户信息">
        <template #default="scope">
          <UserInfo :userId="scope.row.userInfo.id" :row="scope.row.userInfo" showList="name,phone" />
        </template>
      </el-table-column>
      <el-table-column property="" label="猫咪信息">
        <template #default="scope">
          <p v-for="(item,index) in scope.row.petList" :key="index">{{item.petBreedColorName}}（{{item.name}}）</p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="项目"></el-table-column>
      <el-table-column v-if="serviceType != 1 && serviceType != -2 && serviceType != 6" property="money" label="业绩金额"></el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {pageStaffProjectStatList} from "@/api/url";
import UserInfo from "@/components/User/userInfo";

export default {
  name: "userStatList",
  components: {UserInfo},
  props: {
    value: Object
  },
  data() {
     return {

       shopId: this.value.shopId,
       adminId: this.value.adminId,
       statTime: this.value.statTime,
       serviceType: this.value.serviceType,

       pageDataList: [],
       currentPage: 1,
       totalRow: 0,
       pageSize: 20,
       listLoading: false,
       searchLoading: false,
     }
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['adminId'] = this.adminId;
      param['statTime'] = this.statTime;
      param['serviceType'] = this.serviceType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(pageStaffProjectStatList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
